import { Wallet } from '@/components/icons/wallet'
import { Button } from '@/components/ui/button'
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from '@/components/ui/dialog'
import type { FC } from 'react'
import { useCallback, useState } from 'react'

interface Props {
    onConnect: () => void
}

export const ConnectWalletDialog: FC<Props> = ({ onConnect }) => {
    const [isOpen, setIsOpen] = useState(false)

    const handleConnect = useCallback(() => {
        setIsOpen(false)
        onConnect()
    }, [onConnect])

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                <Button>
                    <Wallet />
                    <span>Connect wallet</span>
                </Button>
            </DialogTrigger>
            <DialogContent className="flex flex-col">
                <DialogHeader>
                    <div className="flex flex-col gap-6 justify-center items-center">
                        <Wallet className="w-14 h-14 [&_*]:fill-primary/20 [&_*]:stroke-primary [&_*]:stroke-1" />
                        <div className="flex flex-col gap-5 items-center">
                            <DialogTitle>Connect wallet</DialogTitle>
                            <DialogDescription className="text-text-primary">
                                Lorem ipsum dolor sit amet consectetur. Ultrices molestie elit imperdiet dui lobortis
                                quis dui.
                            </DialogDescription>
                        </div>
                    </div>
                </DialogHeader>
                <div className="flex flex-row gap-4 justify-center items-center">
                    <Button className="grow-0 shrink" onClick={handleConnect}>
                        Connect wallet
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    )
}
